module.exports = __webpack_public_path__ + "img/rubystone_banner_ver2.14627052.png";